<template>
  <div class="thirdaccesstable">
    <el-table :data="tableData" style="width: 100%;padding:10px 10px 0 10px;"  border>
      <el-table-column prop="createMyAt" label="创建时间" width="200"></el-table-column>
      <el-table-column prop="bindId" label="绑定用户编号" width="180">
        <template slot-scope="scope">
          <span>{{scope.row.bindName + ' (UID ' + scope.row.bindId + ' )'}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="bindName" label="绑定用户名称"></el-table-column> -->
      <el-table-column prop="createName" label="创建人"></el-table-column>
      <el-table-column prop="desc" label="备注" width="400"></el-table-column>
      <el-table-column prop="endMyAt" label="截止日期" width="200">
        <template slot-scope="scope">
          <span style="color:red;" v-if="scope.row.endMyAt == '已过期'">{{scope.row.endMyAt}}</span>
          <span v-else>{{scope.row.endMyAt}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="expiryAt" label="状态" width="70">
        <template slot-scope="scope">
          <div v-if="scope.row.expiryAt !== -1">
            <el-tag type="success">{{'激活'}}</el-tag>
          </div>

          <div v-if="scope.row.expiryAt === -1">
            <el-tag type="danger">{{'停用'}}</el-tag>
          </div>

        </template>
      </el-table-column>

      <el-table-column label="操作"
                       width="300">
        <template slot-scope="scope">
          <el-button @click="closeClick(scope)"
                     v-if="scope.row.expiryAt !== -1"
                     style="color:#F96900;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-circle-close"></i>停用</el-button>
          <el-button @click="openClick(scope)"
                     v-if="scope.row.expiryAt === -1"
                     style="color:#13aa65;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-document-checked"></i>激活</el-button>
          <!-- <span style="margin:0 11px;"> | </span>
          <el-button @click="activationClick(scope)"
                     style="color:#13aa65;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-folder-checked"></i>激活</el-button> -->
          <span style="margin:0 11px;"> | </span>
          <el-button @click="seeClick(scope)"
                     style="color:#185ED3;font-weight:bold;font-size:13px;"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right:3px;"
               class="el-icon-link"></i>查看令牌</el-button>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
export default {
  name: "thirdaccesstable",
  props: {
    tableData:Array,
  },
  data() {
    return {
      picMsg:{}
      // tableData: [
        // {
        //   date: "2020-04-21",
        //   type: "公开需求",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // },
        // {
        //   date: "2020-04-21",
        //   type: "定向需求（指定5人）",
        //   title: "用在报纸上的图片",
        //   zhang: "152",
        //   ren: "5645"
        // }
      // ]
    };
  },
  methods: {

    seeClick(scope) {
      this.$emit("seeClick", scope);
    },
    closeClick(scope) {
      this.$emit("closeClick", scope);
    },
    openClick(scope) {
      this.$emit("openClick", scope);
    },
    // activationClick(scope) {
    //   this.$emit("activationClick", scope);
    // },
    quit() {
      this.mydialogVisible = false;
    },
    handleClose() {
      this.mydialogVisible = false;
    },

  },
  created() {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}

.el-table /deep/ .cell .tit:hover{
  text-decoration: underline !important;
}
</style>
